import CompanyIndex from '@/views/management/companies/Index'
import CompanyDetail from '@/views/management/companies/Detail'
import CompanyForm from '@/views/management/companies/Form'
import Administrations from '@/views/management/companies/administrations/Administrations'
import Users from '@/views/management/companies/users/Users'
import Modules from '@/views/management/companies/modules/Modules'

export default [{
    name: 'management:index',
    path: '/management',
    component: {
        template: '<div><router-view /></div>'
    },
    meta: {
        permissionPrefix: "core"
    },
    children: [{
            name: `companies:index`,
            path: `companies`,
            component: CompanyIndex
        },
        {
            name: `companies:create`,
            path: `companies/create`,
            component: CompanyForm
        },
        {
            name: `companies:update`,
            path: `companies/:companyId/update`,
            component: CompanyForm
        },
        {
            name: `companies:detail`,
            path: `companies/:companyId`,
            component: CompanyDetail,
            redirect: `companies/:companyId/administrations`,
            children: [{
                    name: `companies:detail:administrations`,
                    path: 'administrations',
                    component: Administrations
                },
                {
                    name: `companies:detail:users`,
                    path: 'users',
                    component: Users
                },
                {
                    name: `companies:detail:modules`,
                    path: 'modules',
                    component: Modules
                }
            ]
        }
    ]
}]
